import PropTypes from 'prop-types';
import { createContext, useEffect, useContext, useMemo, useCallback } from 'react';
// hooks
import useLocalStorage from '../../hooks/useLocalStorage';
// utils
import localStorageAvailable from '../../utils/localStorageAvailable';
//
import { defaultSettings } from './config-setting';
import { defaultPreset, getPresets, presetsOption } from './presets';
import { HOST_API_access_token } from '../../config-global';


// ----------------------------------------------------------------------

const initialState = {
  ...defaultSettings,
  // Mode
  onToggleMode: () => {},
  onChangeMode: () => {},
  // Direction
  onToggleDirection: () => {},
  onChangeDirection: () => {},
  onChangeDirectionByLang: () => {},
  // Layout
  onToggleLayout: () => {},
  onChangeLayout: () => {},
  // Contrast
  onToggleContrast: () => {},
  onChangeContrast: () => {},
  // Color
  onChangeColorPresets: () => {},
  presetsColor: defaultPreset,
  presetsOption: [],
  // Stretch
  onToggleStretch: () => {},
  // Reset
  onResetSetting: () => {},
};

// ----------------------------------------------------------------------

export const SettingsContext = createContext(initialState);

export const useSettingsContext = () => {
  const context = useContext(SettingsContext);

  if (!context) throw new Error('useSettingsContext must be use inside SettingsProvider');

  return context;
};

// ----------------------------------------------------------------------

SettingsProvider.propTypes = {
  children: PropTypes.node,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useLocalStorage('settings', defaultSettings);

  const storageAvailable = localStorageAvailable();

  const langStorage = storageAvailable ? localStorage.getItem('i18nextLng') : '';

  // const [data, setData] = useState([])
// localStorage.setItem('dataKey', JSON.stringify(data));
const data1={
  "token_type": "Bearer",
  "expires_in": "3599",
  "ext_expires_in": "3599",
  "expires_on": "1671120804",
  "not_before": "1671116904",
  "resource": "5a106a66-b941-41a7-ace1-fc602c5b8da7",
  "access_token1": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyIsImtpZCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyJ9.eyJhdWQiOiI1YTEwNmE2Ni1iOTQxLTQxYTctYWNlMS1mYzYwMmM1YjhkYTciLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8xZTk0OTQ4YS05ZGUxLTQ0ZDAtODVlZC1lZDY2OGM2OWQ2MjYvIiwiaWF0IjoxNjcxMTE2OTA0LCJuYmYiOjE2NzExMTY5MDQsImV4cCI6MTY3MTEyMDgwNCwiYWlvIjoiRTJaZ1lBamZ6TkxUZU9kb0xxdmd4NzlyV1Ira0F3QT0iLCJhcHBpZCI6IjVhMTA2YTY2LWI5NDEtNDFhNy1hY2UxLWZjNjAyYzViOGRhNyIsImFwcGlkYWNyIjoiMSIsImlkcCI6Imh0dHBzOi8vc3RzLndpbmRvd3MubmV0LzFlOTQ5NDhhLTlkZTEtNDRkMC04NWVkLWVkNjY4YzY5ZDYyNi8iLCJvaWQiOiJiNDJkZDFkMS02NTU4LTQ1YzAtODUyNC1hYWNlYjkwNzZmNDkiLCJyaCI6IjAuQVU4QWlwU1VIdUdkMEVTRjdlMW1qR25XSm1acUVGcEJ1YWRCck9IOFlDeGJqYWRQQUFBLiIsInN1YiI6ImI0MmRkMWQxLTY1NTgtNDVjMC04NTI0LWFhY2ViOTA3NmY0OSIsInRpZCI6IjFlOTQ5NDhhLTlkZTEtNDRkMC04NWVkLWVkNjY4YzY5ZDYyNiIsInV0aSI6ImhSeVVnbERfTlVtTm1vb216RFdLQUEiLCJ2ZXIiOiIxLjAifQ.Om3S1-1yVTdqriD2eSV4yvn0V4QwlpmmhAKHJO5YoV1ioRDUsLJ8uvBTWFqVBnxPS2jCmiAXBR8TVXds8VPh6AKcM0ds64DMagH8XVXSB7MbUjTEF5PqCUtj0QP6bXqks101BiZZ2kjHW4u1EKpXdLtqmoj-v-Qf_MbzCDh1lUIyQ7PvoFkGkz7jWXlhNaZWw-3ONpTDPrdKjj0Thn8G-YqUPWLfMmMzoyXbC8MLtfNTI6B6hRAiAl2oMToXkaoHj1CNriMbn1oPlu8g0h-wHvm3EAQl893pYNDnNmzS1AErnjpwy8phbj6R8w6wLG90NeBNVVn_PZSTEXMpAlsHbQ",
  "access_token2":"eyJ0eXAiOiJKV1QiLCJub25jZSI6IjFKQ0FheF9KWEVnQkxmcGJYam00UmlOZzNyRkp4YzVESjNwY0F1VzBabXMiLCJhbGciOiJSUzI1NiIsIng1dCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyIsImtpZCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8xZTk0OTQ4YS05ZGUxLTQ0ZDAtODVlZC1lZDY2OGM2OWQ2MjYvIiwiaWF0IjoxNjcxMTMyMzQyLCJuYmYiOjE2NzExMzIzNDIsImV4cCI6MTY3MTEzNzQ0MiwiYWNjdCI6MCwiYWNyIjoiMSIsImFpbyI6IkFUUUF5LzhUQUFBQTc1UjNOQzExNXExZDZrSVYxamRVVllueEpRZVpWS1BhSklHdHU3QnEvNEl3djY3TTc5SEZqYmZPMXEvZzF3MG0iLCJhbXIiOlsicHdkIl0sImFwcF9kaXNwbGF5bmFtZSI6IkRRQ19EZW1vIiwiYXBwaWQiOiJiZmU0MDZmYy0yZWYzLTQ5MGUtYTQwOS0wYTQ0YTMwMjU2N2QiLCJhcHBpZGFjciI6IjAiLCJmYW1pbHlfbmFtZSI6IkRhbmVzY3UiLCJnaXZlbl9uYW1lIjoiTWloYWkiLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiI4Ni45NS4yNDcuMjA1IiwibmFtZSI6Ik1paGFpIERhbmVzY3UiLCJvaWQiOiJiZGNkOTBiMy1jMmQ4LTQyZTYtYTFlZi04MzFkNmM4NzYxZTkiLCJwbGF0ZiI6IjUiLCJwdWlkIjoiMTAwMzIwMDFFRTM3MEI4RCIsInJoIjoiMC5BVThBaXBTVUh1R2QwRVNGN2UxbWpHbldKZ01BQUFBQUFBQUF3QUFBQUFBQUFBQlBBUHcuIiwic2NwIjoib3BlbmlkIHByb2ZpbGUgVXNlci5SZWFkIGVtYWlsIiwic3ViIjoiUE1ZRTBaZng3ZkFsM2p2aHRiZ3AyVTZTNllkVk5tSDlyU2ltemxwbDRLOCIsInRlbmFudF9yZWdpb25fc2NvcGUiOiJFVSIsInRpZCI6IjFlOTQ5NDhhLTlkZTEtNDRkMC04NWVkLWVkNjY4YzY5ZDYyNiIsInVuaXF1ZV9uYW1lIjoibWloYWlAREFUQVFVQUxJVFlDT01QQU5ZLk5MIiwidXBuIjoibWloYWlAREFUQVFVQUxJVFlDT01QQU5ZLk5MIiwidXRpIjoiUGgxeUtSdlREVU9XRVRRc3NRRUFBUSIsInZlciI6IjEuMCIsIndpZHMiOlsiNjJlOTAzOTQtNjlmNS00MjM3LTkxOTAtMDEyMTc3MTQ1ZTEwIiwiYjc5ZmJmNGQtM2VmOS00Njg5LTgxNDMtNzZiMTk0ZTg1NTA5Il0sInhtc19zdCI6eyJzdWIiOiJkNEphZ3dobWlQYzNhTlYzSVBENWJkWkVocEtVdFlyZWpWUU9ncFJheS1nIn0sInhtc190Y2R0IjoxNjQ1MzU0NzMwLCJ4bXNfdGRiciI6IkVVIn0.O82YAquex3j5hHqgcjUdWtDAy7KRu154QFtU_kmrsxOSS0P_ah3p88QKciA30IMbThdpUjzz4voLhcr0hR7ZGtufWBsIjzo18whkrICmqqCkQqmZyXuOINtPSyt4r6le3amLuhwwcL1vvQMdXUOyefPk-znOLjcYoZonQOSOEGpKyVZxeabbo3HUx7aGUfuqTO1pK499PTdkTwxCipS0JVf133XbKiU6GmT1fUlhCBHhWnrhNrbjaYqwCgWxOxEdtOFQgpyViE_jiCXhE1n9ffX8aSFDhWTP3g871TJrhhG1WrfCHEZ3kWd84NdwRYQoLuaPD5I2lZ4bdJJP3nzmsw",
  "access_token3": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyIsImtpZCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyJ9.eyJhdWQiOiI1YTEwNmE2Ni1iOTQxLTQxYTctYWNlMS1mYzYwMmM1YjhkYTciLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8xZTk0OTQ4YS05ZGUxLTQ0ZDAtODVlZC1lZDY2OGM2OWQ2MjYvIiwiaWF0IjoxNjcyMzE3MDU3LCJuYmYiOjE2NzIzMTcwNTcsImV4cCI6MTY3MjMyMDk1NywiYWlvIjoiRTJaZ1lNZ3QrbWUrUTFlVHJYbnF0NzBxSDU0OUJBQT0iLCJhcHBpZCI6IjVhMTA2YTY2LWI5NDEtNDFhNy1hY2UxLWZjNjAyYzViOGRhNyIsImFwcGlkYWNyIjoiMSIsImlkcCI6Imh0dHBzOi8vc3RzLndpbmRvd3MubmV0LzFlOTQ5NDhhLTlkZTEtNDRkMC04NWVkLWVkNjY4YzY5ZDYyNi8iLCJvaWQiOiJiNDJkZDFkMS02NTU4LTQ1YzAtODUyNC1hYWNlYjkwNzZmNDkiLCJyaCI6IjAuQVU4QWlwU1VIdUdkMEVTRjdlMW1qR25XSm1acUVGcEJ1YWRCck9IOFlDeGJqYWRQQUFBLiIsInN1YiI6ImI0MmRkMWQxLTY1NTgtNDVjMC04NTI0LWFhY2ViOTA3NmY0OSIsInRpZCI6IjFlOTQ5NDhhLTlkZTEtNDRkMC04NWVkLWVkNjY4YzY5ZDYyNiIsInV0aSI6InMxTnhGZE45c2tXTjdZODhHX2ZwQUEiLCJ2ZXIiOiIxLjAifQ.EDiUjzP3mDqptoMwbiKtzdTep4CEIpnrX1nFclD_qtzHz6L4K8mX0cMSQaO_hFUHtfr0Ok3fstj5BKA5oAZhMdoxq5XhDaeH13VLKjD2lOD30-z_Ac1nRmKPSPJjRJgCiKtcT-eI7AHmpsE5m4fsZ3zH_KDXRqBKrzl0M5dn2734uGud9tH1lRiElqQd0YwOFWEH9bK1h3u0MVYAGTnai3ksKzzWdpgeW0-cUsjJjzvUl2sSNmExuS-xcZRUGlpLny8uSg2QloX8AUD_0iL1tlTrbdLgP03GrxUzYi2k-cqCgUJrfRWNBuswLZ2b82mSRytiH6aWXIXdGK94jdblkQ"
};

const data2={access_token:HOST_API_access_token}; 

  localStorage.setItem("auth",JSON.stringify(data1))

  const isArabic = langStorage === 'ar';

  useEffect(() => {
    if (isArabic) {
      onChangeDirectionByLang('ar');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isArabic]);

  // Mode
  const onToggleMode = useCallback(() => {
    const themeMode = settings.themeMode === 'light' ? 'dark' : 'light';
    setSettings({ ...settings, themeMode });
  }, [setSettings, settings]);

  const onChangeMode = useCallback(
    (event) => {
      const themeMode = event.target.value;
      setSettings({ ...settings, themeMode });
    },
    [setSettings, settings]
  );

  // Direction
  const onToggleDirection = useCallback(() => {
    const themeDirection = settings.themeDirection === 'rtl' ? 'ltr' : 'rtl';
    setSettings({ ...settings, themeDirection });
  }, [setSettings, settings]);

  const onChangeDirection = useCallback(
    (event) => {
      const themeDirection = event.target.value;
      setSettings({ ...settings, themeDirection });
    },
    [setSettings, settings]
  );

  const onChangeDirectionByLang = useCallback(
    (lang) => {
      const themeDirection = lang === 'ar' ? 'rtl' : 'ltr';
      setSettings({ ...settings, themeDirection });
    },
    [setSettings, settings]
  );

  // Layout
  const onToggleLayout = useCallback(() => {
    const themeLayout = settings.themeLayout === 'vertical' ? 'mini' : 'vertical';
    setSettings({ ...settings, themeLayout });
  }, [setSettings, settings]);

  const onChangeLayout = useCallback(
    (event) => {
      const themeLayout = event.target.value;
      setSettings({ ...settings, themeLayout });
    },
    [setSettings, settings]
  );

  // Contrast
  const onToggleContrast = useCallback(() => {
    const themeContrast = settings.themeContrast === 'default' ? 'bold' : 'default';
    setSettings({ ...settings, themeContrast });
  }, [setSettings, settings]);

  const onChangeContrast = useCallback(
    (event) => {
      const themeContrast = event.target.value;
      setSettings({ ...settings, themeContrast });
    },
    [setSettings, settings]
  );

  // Color
  const onChangeColorPresets = useCallback(
    (event) => {
      const themeColorPresets = event.target.value;
      setSettings({ ...settings, themeColorPresets });
    },
    [setSettings, settings]
  );

  // Stretch
  const onToggleStretch = useCallback(() => {
    const themeStretch = !settings.themeStretch;
    setSettings({ ...settings, themeStretch });
  }, [setSettings, settings]);

  // Reset
  const onResetSetting = useCallback(() => {
    setSettings(defaultSettings);
  }, [setSettings]);

  const memoizedValue = useMemo(
    () => ({
      ...settings,
      // Mode
      onToggleMode,
      onChangeMode,
      // Direction
      onToggleDirection,
      onChangeDirection,
      onChangeDirectionByLang,
      // Layout
      onToggleLayout,
      onChangeLayout,
      // Contrast
      onChangeContrast,
      onToggleContrast,
      // Stretch
      onToggleStretch,
      // Color
      onChangeColorPresets,
      presetsOption,
      presetsColor: getPresets(settings.themeColorPresets),
      // Reset
      onResetSetting,
    }),
    [
      settings,
      // Mode
      onToggleMode,
      onChangeMode,
      // Direction
      onToggleDirection,
      onChangeDirection,
      onChangeDirectionByLang,
      // Layout
      onToggleLayout,
      onChangeLayout,
      onChangeContrast,
      // Contrast
      onToggleContrast,
      // Stretch
      onToggleStretch,
      // Color
      onChangeColorPresets,
      // Reset
      onResetSetting,
    ]
  );

  return <SettingsContext.Provider value={memoizedValue}>{children}</SettingsContext.Provider>;
}
